import * as z$1 from "zod/v4";
//#region src/schemas/http/feedback.ts
const FEEDBACK_SUBMIT_INVALID_INPUT_ERROR_CODE = "feedback.submit.invalid_input";
const FEEDBACK_SUBMIT_INBOX_NOT_FOUND_ERROR_CODE = "feedback.submit.inbox_not_found";
const FEEDBACK_SUBMIT_RATE_LIMITED_ERROR_CODE = "feedback.submit.rate_limited";
const FEEDBACK_SUBMIT_DISABLED_ERROR_CODE = "feedback.submit.disabled";
const FEEDBACK_ISSUE_NOT_FOUND_ERROR_CODE = "feedback.issue.not_found";
const FEEDBACK_ISSUE_INVALID_INPUT_ERROR_CODE = "feedback.issue.invalid_input";
const FEEDBACK_ISSUE_INVALID_TRANSITION_ERROR_CODE = "feedback.issue.invalid_transition";
const FEEDBACK_SUBMIT_ERROR_CODES = [
	FEEDBACK_SUBMIT_INVALID_INPUT_ERROR_CODE,
	FEEDBACK_SUBMIT_INBOX_NOT_FOUND_ERROR_CODE,
	FEEDBACK_SUBMIT_RATE_LIMITED_ERROR_CODE,
	FEEDBACK_SUBMIT_DISABLED_ERROR_CODE
];
const FEEDBACK_ISSUE_ERROR_CODES = [
	FEEDBACK_ISSUE_NOT_FOUND_ERROR_CODE,
	FEEDBACK_ISSUE_INVALID_INPUT_ERROR_CODE,
	FEEDBACK_ISSUE_INVALID_TRANSITION_ERROR_CODE
];
const boundedIdentifierSchema = z$1.string().trim().min(1).max(256);
const timestampMsSchema = z$1.number().int().nonnegative();
const FEEDBACK_ISSUE_CATEGORIES = [
	"bug",
	"experience",
	"idea",
	"question"
];
const feedbackIssueCategorySchema = z$1.enum(FEEDBACK_ISSUE_CATEGORIES);
const feedbackSubmitterKindSchema = z$1.enum([
	"human",
	"local_agent",
	"center_agent"
]);
const FEEDBACK_ISSUE_STATUSES = [
	"new",
	"dismissed",
	"investigating",
	"ticketed",
	"needs_human",
	"resolved"
];
const feedbackIssueStatusSchema = z$1.enum(FEEDBACK_ISSUE_STATUSES);
const feedbackSubmitErrorCodeSchema = z$1.enum(FEEDBACK_SUBMIT_ERROR_CODES);
const feedbackIssueErrorCodeSchema = z$1.enum(FEEDBACK_ISSUE_ERROR_CODES);
const feedbackClientContextSchema = z$1.strictObject({
	clientKind: z$1.enum([
		"web",
		"cli",
		"desktop",
		"center_agent",
		"other"
	]).optional(),
	clientVersion: z$1.string().max(64).optional(),
	os: z$1.string().max(64).optional()
});
const submitFeedbackIssueRequestSchema = z$1.strictObject({
	category: feedbackIssueCategorySchema,
	summary: z$1.string().min(1).max(200),
	details: z$1.string().max(4e3).optional(),
	submitterKind: feedbackSubmitterKindSchema,
	sourceOrganizationId: z$1.string().optional(),
	contactEmail: z$1.email().optional(),
	clientContext: feedbackClientContextSchema.optional()
});
const submitFeedbackIssueResponseSchema = z$1.strictObject({
	ok: z$1.literal(true),
	issueId: z$1.string().min(1)
});
const feedbackIssueSubmitRpcRequestSchema = z$1.strictObject({
	inboxKey: z$1.string().min(1).max(256),
	request: submitFeedbackIssueRequestSchema,
	submitterUserId: z$1.string().min(1).nullable()
});
const feedbackIssueCursorSchema = z$1.strictObject({
	createdAtMs: timestampMsSchema,
	issueId: boundedIdentifierSchema
});
const feedbackIssueRecordSchema = z$1.strictObject({
	issueId: boundedIdentifierSchema,
	inboxId: boundedIdentifierSchema,
	organizationId: boundedIdentifierSchema,
	category: feedbackIssueCategorySchema,
	summary: z$1.string().min(1).max(200),
	details: z$1.string().max(4e3).nullable(),
	submitterKind: feedbackSubmitterKindSchema,
	submitterUserId: z$1.string().nullable(),
	sourceOrganizationId: z$1.string().nullable(),
	contactEmail: z$1.email().nullable(),
	clientContext: feedbackClientContextSchema.nullable(),
	status: feedbackIssueStatusSchema,
	triageNote: z$1.string().max(2e3).nullable(),
	createdAtMs: timestampMsSchema,
	updatedAtMs: timestampMsSchema
});
const listFeedbackIssuesForOrganizationRequestSchema = z$1.strictObject({
	organizationId: boundedIdentifierSchema,
	status: feedbackIssueStatusSchema.optional(),
	cursor: feedbackIssueCursorSchema.optional(),
	limit: z$1.number().int().min(1).max(100).optional()
});
const listFeedbackIssuesForOrganizationResponseSchema = z$1.strictObject({
	items: z$1.array(feedbackIssueRecordSchema),
	nextCursor: feedbackIssueCursorSchema.nullable()
});
const updateFeedbackIssueStatusForOrganizationRequestSchema = z$1.strictObject({
	organizationId: boundedIdentifierSchema,
	issueId: boundedIdentifierSchema,
	status: feedbackIssueStatusSchema,
	triageNote: z$1.string().max(2e3).optional()
});
const feedbackReportingPolicyResponseSchema = z$1.strictObject({
	organizationId: boundedIdentifierSchema,
	reportingEnabled: z$1.boolean(),
	updatedByUserId: boundedIdentifierSchema.nullable()
});
const readFeedbackReportingPolicyRequestSchema = z$1.strictObject({ organizationId: boundedIdentifierSchema });
const updateFeedbackReportingPolicyBodySchema = z$1.strictObject({ reportingEnabled: z$1.boolean() });
//#endregion
export { FEEDBACK_ISSUE_CATEGORIES, FEEDBACK_ISSUE_ERROR_CODES, FEEDBACK_ISSUE_INVALID_INPUT_ERROR_CODE, FEEDBACK_ISSUE_INVALID_TRANSITION_ERROR_CODE, FEEDBACK_ISSUE_NOT_FOUND_ERROR_CODE, FEEDBACK_ISSUE_STATUSES, FEEDBACK_SUBMIT_DISABLED_ERROR_CODE, FEEDBACK_SUBMIT_ERROR_CODES, FEEDBACK_SUBMIT_INBOX_NOT_FOUND_ERROR_CODE, FEEDBACK_SUBMIT_INVALID_INPUT_ERROR_CODE, FEEDBACK_SUBMIT_RATE_LIMITED_ERROR_CODE, feedbackClientContextSchema, feedbackIssueCategorySchema, feedbackIssueCursorSchema, feedbackIssueErrorCodeSchema, feedbackIssueRecordSchema, feedbackIssueStatusSchema, feedbackIssueSubmitRpcRequestSchema, feedbackReportingPolicyResponseSchema, feedbackSubmitErrorCodeSchema, feedbackSubmitterKindSchema, listFeedbackIssuesForOrganizationRequestSchema, listFeedbackIssuesForOrganizationResponseSchema, readFeedbackReportingPolicyRequestSchema, submitFeedbackIssueRequestSchema, submitFeedbackIssueResponseSchema, updateFeedbackIssueStatusForOrganizationRequestSchema, updateFeedbackReportingPolicyBodySchema };

//# sourceMappingURL=feedback.js.map